import classNames from 'classnames'
import { observer } from 'mobx-react-lite'

import styles from './HeaderActivity.module.less'
import { routerService } from '@/services/routerService'
import { userService } from '@/services/userService'
import { useCallback } from 'react'
import { commonUtils } from '@/helpers/commonUtils'

export interface HeaderActivityProps {
  isScrolling?: boolean
  onClick?: () => void
}

export const HeaderActivity = observer((props: HeaderActivityProps) => {
  const { isScrolling, onClick } = props

  const activityClick = useCallback(() => {
    if (onClick) {
      onClick()
      return
    }

    const version = userService.userData?.versionData.version
    let v = 'ultra'
    if (version === 'free') {
      v = 'max'
    }
    routerService.navigateTo('pricing', {
      from: 'video_activity',
      feature: 'normal',
      v,
    })
  }, [])

  let imgUrl = commonUtils.getStaticFile('top_video_main_normal.png')
  if (userService.userData && userService.userData.newUserDiscount) {
    imgUrl = commonUtils.getStaticFile('top_video_main.png')
  }

  return (
    <div className={classNames(styles.headerActivity)}>
      <div className={classNames(styles.activityBox)} onClick={activityClick}>
        <img src={imgUrl} className={classNames(styles.icon)} />

        <img
          src={commonUtils.getStaticFile('top_video_btn.png')}
          className={classNames(styles.btn)}
        />
      </div>
    </div>
  )
})
